export default {
  moduleName: "layout",
  namespaced: true,
  persistent: ["layoutType", "layoutWidth", "leftSidebarType", "topbar", "loader", "isMenuCollapsed"],
  state: () => ({
    layoutType: "vertical",
    layoutWidth: "fluid",
    leftSidebarType: "dark",
    topbar: "dark",
    loader: false,
    isMenuCollapsed: false,
    isRightSidebarActive: false,
  }),
  getters: {
    isMenuCollapsed: (state) => state.isMenuCollapsed,
    isRightSidebarActive: (state) => state.isRightSidebarActive,
  },
  mutations: {
    CHANGE_LAYOUT(state, layoutType) {
      state.layoutType = layoutType;
    },
    CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
      state.layoutWidth = layoutWidth;
    },
    CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
      state.leftSidebarType = leftSidebarType;
    },
    CHANGE_TOPBAR(state, topbar) {
      state.topbar = topbar;
    },
    LOADER(state, loader) {
      state.loader = loader;
    },
    CHANGE_MENU_COLLAPSE(state) {
      state.isMenuCollapsed = !state.isMenuCollapsed;
    },
    MENU_COLLAPSE(state) {
      state.isMenuCollapsed = true;
    },
    SHOW_RIGHT_SIDEBAR(state) {
      state.isRightSidebarActive = true;
    },
    HIDE_RIGHT_SIDEBAR(state) {
      state.isRightSidebarActive = false;
    },

    TOGGLE_RIGHT_SIDEBAR(state) {
      state.isRightSidebarActive = !state.isRightSidebarActive;
    },

    reset(state) {
      state.layoutType = "vertical";
      state.layoutWidth = "fluid";
      state.leftSidebarType = "dark";
      state.topbar = "dark";
      state.loader = false;
      state.isMenuCollapsed = false;
    },
  },
  actions: {
    changeLayoutType({ commit }, { layoutType }) {
      commit("CHANGE_LAYOUT", layoutType);
    },

    changeLayoutWidth({ commit }, { layoutWidth }) {
      commit("CHANGE_LAYOUT_WIDTH", layoutWidth);
    },

    changeLeftSidebarType({ commit }, { leftSidebarType }) {
      commit("CHANGE_LEFT_SIDEBAR_TYPE", leftSidebarType);
    },

    changeTopbar({ commit }, { topbar }) {
      commit("CHANGE_TOPBAR", topbar);
    },

    changeLoaderValue({ commit }, { loader }) {
      commit("LOADER", loader);
    },
    toggleMenuCollapse({ commit }) {
      commit("CHANGE_MENU_COLLAPSE");
    },
    MenuCollapse({ commit }) {
      commit("MENU_COLLAPSE");
    },
    SHOW_RIGHT_SIDEBAR({ commit }) {
      commit("SHOW_RIGHT_SIDEBAR");
    },

    HIDE_RIGHT_SIDEBAR({ commit }) {
      commit("HIDE_RIGHT_SIDEBAR");
    },
    TOGGLE_RIGHT_SIDEBAR({ commit }) {
      commit("TOGGLE_RIGHT_SIDEBAR");
    },
  },
};
